module.exports = __webpack_public_path__ + "../resources/img/ic-zoomout.a4c0f14e.svg";